import { HNG_APP_CONFIG, HngAppConfig } from '@hidat/ng-common';
import { environment } from '../environments/environment';
import { EventTrackerConfig, EventTrackerModule, loadStationInitializer } from '@splixer/player';
import {
  ApplicationConfig,
  importProvidersFrom,
  provideAppInitializer,
  provideZoneChangeDetection
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule } from 'ngx-google-analytics';
import { appRoutes } from './app.routes';

const appConfig = new HngAppConfig({
  appCode: 'knkx-player',
  appName: 'KNKX On Demand',
  apiUrl: environment.splixerUrl,
  userApiUrl: '',
});

const eventTrackerConfig: EventTrackerConfig = {
  primaryTrackingCode: environment.defaultGaTrackingId,
};

export const knkxConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
    { provide: HNG_APP_CONFIG, useValue: appConfig },
    importProvidersFrom(NgxGoogleAnalyticsModule.forRoot(environment.defaultGaTrackingId)),
    importProvidersFrom(NgxGoogleAnalyticsRouterModule),
    importProvidersFrom(EventTrackerModule.forRoot(eventTrackerConfig)),
    provideAppInitializer(() => {
      return loadStationInitializer(environment.defaultStationCode, {featured: true, recents:  false, genres: false, mixCategories: false});
    })
  ],
}
